import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import parse from "html-react-parser";

export class Modal extends PureComponent {
  static propTypes = {
    buttons: PropTypes.array,
    className: PropTypes.string,
    message: PropTypes.string,
    modalClassName: PropTypes.string,
    title: PropTypes.string
  };

  static defaultProps = {
    buttons: [],
    className: "",
    message: "",
    modalClassName: "",
    title: ""
  };

  render() {
    return (
      <div className={classNames("modal", this.props.className)} role="presentation">
        <article className={classNames("modal__box", this.props.modalClassName)} role="presentation" onClick={event => event.stopPropagation()}>
          {this.props.title && <h3 className="modal__title">{this.props.title}</h3>}
          {this.props.message && <h4 className="modal__message">{parse(this.props.message)}</h4>}
          <footer className="modal__actions">
            {this.props.buttons.map(button => (
              <button key={button.label} className="modal__button" onClick={button.onClose}>
                {button.label}
              </button>
            ))}
          </footer>
        </article>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Modal.js